import React from 'react';
import { FilterProps } from 'react-table';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

export const TableSelectFilterWithSearch = (source: any) => (props: FilterProps<any>) => {
  const {
    state: { filters },
    column,
    setAllFilters,
  } = props;

  const columnFilter = filters.filter((filter) => filter.id === column.id);

  const ValueContainer = ({ children, ...props }: any) => {
    const { t } = useTranslation();

    const { getValue } = props;
    const nbValues = getValue().length;

    return (
      <div className="ms-1">
        <span>{`${nbValues} ${t('table.filter.selected')}`}</span>
        {children[1]} {/* Children[1] contains the element responsible of the open - close behaviors */}
      </div>
    );
  };

  return (
    <Select
      value={columnFilter}
      isMulti
      closeMenuOnSelect={false}
      options={source}
      onChange={(e) => {
        if (Array.isArray(e)) {
          setAllFilters([
            ...props.state.filters.filter((filter) => filter.id !== props.column.id),
            ...e.map((el: any) => ({
              id: props.column.id,
              value: el.value,
              label: el.label,
            })),
          ]);
        }
      }}
      hideSelectedOptions={false}
      components={{ ValueContainer }}
    />
  );
};
